import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import {KeyValuePipe, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {NzButtonComponent} from 'ng-zorro-antd/button';

@Component({
  selector: 'app-formulario-general',
  templateUrl: './formulario-general.component.html',
  imports: [
    NgSwitch,
    NgIf,
    ReactiveFormsModule,
    NgForOf,
    KeyValuePipe,
    NgSwitchDefault,
    NgSwitchCase,
    NzButtonComponent
  ],
  styleUrls: ['./formulario-general.component.css']
})
export class FormularioGeneralComponent implements OnInit {
  form!: FormGroup;
  configForm: { [key: string]: any } = {};
  isEditMode = false;

  constructor(private fb: FormBuilder, private modalRef: NzModalRef) {}

  ngOnInit(): void {
    const params = this.modalRef.getConfig().nzData;

    if (!params) {
    //  console.error('No se recibió configForm en nzData');
      return;
    }

    this.configForm = params.formConfig || {};
    this.isEditMode = !!params.initialData;

    this.initializeForm(params.initialData || {});
  }

  initializeForm(initialData: any): void {
    const group: { [key: string]: any } = {};

    for (const field of Object.keys(this.configForm)) {
      let initialValue = initialData[field] || '';

      if (field === 'tipo_institucion' && initialValue && typeof initialValue === 'object') {
        initialValue = initialValue.id_tipo_institucion;
      }

      group[field] = [
        initialValue,
        this.configForm[field].validators || [],
      ];
    }

    this.form = this.fb.group(group);
  }

  onSubmit(): void {
    if (this.form.invalid) return;

    const params = this.modalRef.getConfig().nzData;
    const data = { ...this.form.value };
    const service = params.service;

    // Ensure id_tipo_institucion is correctly set
    if (data.tipo_institucion) {
      const selectedTipoInstitucion = this.configForm['tipo_institucion'].options.find(
        (option: any) => option.value == data.tipo_institucion // Comparación con `==` por seguridad
      );
      if (selectedTipoInstitucion) {
        data.id_tipo_institucion = selectedTipoInstitucion.value;
        delete data.tipo_institucion; // Remove the original tipo_institucion field
      }
    }

    if (this.isEditMode) {
      const idField = Object.keys(params.initialData).find(key => key.startsWith('id_')) || 'id';

      service.update({ ...data, [idField]: params.initialData[idField] }).subscribe(
        (response: any) => {
          this.modalRef.close(response);
        },
        (error: any) => {
     //     console.error('Error al actualizar:', error);
        }
      );
    } else {
      service.create(data).subscribe(
        (response: any) => {
          this.modalRef.close(response);
        },
        (error: any) => {
     //     console.error('Error al crear:', error);
        }
      );
    }
  }


  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;
  //  console.log('Selected id_tipo_institucion:', selectedValue);
    this.form.patchValue({ tipo_institucion: selectedValue });
  }


  cancelar(): void {
    this.modalRef.close();
  }
}
